export default __webpack_public_path__ + "static/media/AccountMenu.3569bd4c.md";